import React from "react";

function FilterBar({ searchTerm, setSearchTerm }) {
  return (
    <div className="filter-bar" style={{ marginBottom: "20px" }}>
      <input
        type="text"
        placeholder="🔍 Search projects by name, code, client, location, or leads..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: "100%",
          padding: "10px 14px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "14px",
          boxSizing: "border-box"
        }}
      />
    </div>
  );
}

export default FilterBar;